import { PerspectiveCamera } from '@react-three/drei'
import React, { RefObject, useEffect, useMemo, useRef, useState } from 'react'
import Field from './models/field/Field'
import { Baseball } from './models/baseballs/Baseball'
import * as THREE from 'three'
import { Handedness } from '@/utils/types'
import { Rhp2SFB } from './models/grips/RHP_2SFB_grip'
import { getReleasePoint } from '@/utils/pitch-designer/getReleasePoint'
import { useSpring, useSpringValue } from '@react-spring/three'
import { useFrame } from '@react-three/fiber'

interface Props {
    containerRef: RefObject<HTMLDivElement>
    handedness: Handedness
    heightInches: number
    armTiltDeg: number
}
const ArmAngleScene = ({containerRef, handedness, heightInches, armTiltDeg} : Props) => {
    const fov = 50
    const releaseY = -56
    const cameraRef = useRef<THREE.PerspectiveCamera>(null!);
    const ballGroupRef = useRef<THREE.Group>(null!);
    const ballRef = useRef<THREE.Group>(null!);
    const releasePoint = useMemo(() => {
        return getReleasePoint(heightInches / 12, armTiltDeg, handedness)
    },[heightInches, armTiltDeg, handedness])
    const [aspectRatio, setAspectRatio] = useState<number>(1);
    // Pitcher View camera position
  const pitcherViewCameraPosition = useMemo(() => {
    console.debug("releasePoint received:", releasePoint);
    const ballY = 2 / Math.tan(fov.toRadians()); // Adjust constant to change distance from ball
    const ballX = 2 / (aspectRatio * Math.tan(fov.toRadians())); // Adjust constant to change distance from ball
    return {
      x: releasePoint.x,
      y: releaseY - Math.max(ballY, ballX),
      z: releasePoint.z,
    };
  }, [releasePoint, heightInches, aspectRatio, fov]);
  const cameraPosX = useSpringValue(0);
  const cameraPosY = useSpringValue(-57);
  const cameraPosZ = useSpringValue(6.183);


  // Set aspect ratio
  useEffect(() => {
    if (!!containerRef.current) {
      setAspectRatio(
        containerRef.current.clientWidth / containerRef.current.clientHeight
      );
    }
  }, [containerRef]);

  // Handle PitcherView Camera Position Changing
  useEffect(() => {
    if (!!cameraRef.current) {
      cameraPosX.set(pitcherViewCameraPosition.x);
      cameraPosY.set(pitcherViewCameraPosition.y);
      cameraPosZ.set(pitcherViewCameraPosition.z);
    }
  }, [pitcherViewCameraPosition]);

  useFrame(() => {
    if (!!cameraRef.current) {
      cameraRef.current.position.set(
        cameraPosX.get(),
        cameraPosY.get(),
        cameraPosZ.get()
      );
    }
  })


  return (
    <>
      <ambientLight args={["#fff", 1]} />
      <directionalLight color={"white"} position={[releasePoint.x, releaseY - 7, releasePoint.z]} />
      <PerspectiveCamera
        ref={cameraRef}
        makeDefault
        fov={fov}
        rotation={[Math.PI / 2, 0, 0]}
      />
      {/* <PerspectiveCamera ref={cameraRef} makeDefault position={[0, 60, 200]} rotation={[0, 0, Math.PI]}  /> */}

      <group ref={ballGroupRef} position={[releasePoint.x, releaseY, releasePoint.z]} rotation={[0, armTiltDeg.toRadians(), 0]}>
        <group ref={ballRef}>
            <group rotation={[-Math.PI / 2, 0, 0]}>
                <Baseball />
            </group>
        </group>
      </group>

      <group 
        scale={handedness === 'rh' ? [1,1,1] : [-1,1,1]}
        rotation={[Math.PI/2, 0, -armTiltDeg.toRadians()]}
        position={[releasePoint.x, releaseY, releasePoint.z]}
        >
        <Rhp2SFB />
      </group>

      {/* <BaseballField /> */}
      <Field />
    </>
  )
}

export default ArmAngleScene